import ManualSelectPermissionsDialog from "./manual-select-permissions-dialog.jsx";

export default ManualSelectPermissionsDialog;